import React from 'react';

export function LikeIcon() {
  return (
    <svg width="92" height="84" viewBox="0 0 92 84"  fill="none" className='size-3.5' xmlns="http://www.w3.org/2000/svg">
      <rect x="75.0005" y="34.0312" width="17" height="46" rx="8.5" fill="currentColor" />
      <path
        d="M68.0004 71.6948C67.9454 72.2711 67.6554 73.5966 66.9353 74.2883C66.2151 74.9801 62.9525 78.1992 61.4112 79.7223C60.1827 80.8238 56.3628 83.0269 50.9117 83.0269H24.8566C22.8392 83.115 17.992 81.8822 14.7427 76.246L1.45764 46.4186C0.971901 45.4458 -0.0233622 42.5817 0.000416109 38.9081V35.6523C0.243255 32.9629 2.34025 27.5782 8.78553 27.5782H32.9125L27.2004 13.3163C26.5452 10.7475 26.3409 4.9673 30.7653 2.39669C35.1898 -0.173912 39.212 1.24818 40.391 2.60813L48.8093 13.7154C52.6404 19.2913 61.3752 31.3333 65.6659 34.8938C66.4439 35.4372 67.9998 37.2083 67.9998 39.9455L68.0004 71.6948Z"
        fill="currentColor"
      />
    </svg>
  );
}
